// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2znRR","Icon":"Languages_Icon__2B7Ve","LanguagesSelect":"Languages_LanguagesSelect__1gYRC","minimalist":"Languages_minimalist__1VU9L"};